'use client';

import { isMobile } from 'react-device-detect';
import { USER_LOGIN_STATUS } from './constants';

interface pageNameTierProps {
    [key: string]: string;
}

function generateDate() {
    let now = new Date();
    return (
        now.getFullYear().toString() +
        (now.getMonth() + 1).toString() +
        now.getDate().toString() +
        '-' +
        now.getHours().toString() +
        now.getMinutes().toString()
    );
}

export const deviceDetect = () => {
    if (isMobile) return 'mobile';
    return 'desktop';
};

export const EVENTS = {
    CUSTOM_PAGE_VIEW: 'customPageView',
    SELECT_MARCA: 'selectMarca',
    SELECT_MODELO: 'selectModelo',
    SELECT_ANO: 'selectAno',
    SELECT_VERSAO: 'selectVersao',
    SELECT_ESTADO: 'selectEstado',
    CONSULTAR_VALOR: 'consultarValor',
};

export const handlePropWebSiteAnalytics = () => {
    if (!window.objDataLayer) window.objDataLayer = {};
    if (!window.objDataLayer.site) window.objDataLayer.site = {};
    window.objDataLayer.site = {
        domain: 'webmotors.com.br',
        country: 'brasil',
        server: 'web',
        environment: 'servicos',
        subEnvironment: 'tabela-fipe',
        tmsVersion: generateDate(),
        clientType: 'pf',
        platform: deviceDetect(),
    };
};

export const getTiers = (pathName: string): pageNameTierProps => {
    const pathname = pathName.replace('/webmotors/', '');

    const tiers = pathname.split('/');
    let pathNames = {};
    tiers.map((tier, i) => {
        pathNames[`tier${i + 1}`] = tier === '' ? 'home' : tier;
    });

    return pathNames;
};

export function getQueryParameter(query: string | string[], key: string) {
    if (query && typeof query == 'string') {
        query = query.trim();
    } else {
        return undefined;
    }
    if (key && typeof key == 'string') {
        key = key.trim();
    } else {
        return undefined;
    }
    query = query.replace('?', '');
    query = query.split('&');
    for (let i = 0; i < query.length; i++) {
        if (query[i].split('=')[0] == key) {
            return query[i].split('=')[1];
        }
    }
    return undefined;
}

export const handlePropPageAnalytics = (pageType: string, customPageName?: string) => {
    const pageName = customPageName ? customPageName : window.location.pathname;
    const location = window.location;
    const trackingCodeIcId = getQueryParameter(location.search, 'icid');
    const trackingCodeIdcmp = getQueryParameter(location.search, 'idcmp');
    const trackingCodeLkid = getQueryParameter(location.search, 'lkid');
    const trackingCodeIdcmpint = getQueryParameter(location.search, 'idcmpint');

    let pageNameTier = getTiers(pageName);
    const { tier1, tier2 } = pageNameTier;
    if (!window.objDataLayer.page) window.objDataLayer.page = {};

    window.objDataLayer.page.flowType = 'tabela-fipe';
    window.objDataLayer.page.pageType = pageType;
    window.objDataLayer.page.pageName = pageName;
    window.objDataLayer.page.pageNameTier1 = tier1;
    window.objDataLayer.page.pageNameTier2 = tier2;
    window.objDataLayer.page.url = location.href;
    window.objDataLayer.page.trackingCode = {
        icid: trackingCodeIcId,
        idcmp: trackingCodeIdcmp,
        idcmpint: trackingCodeIdcmpint,
        lkid: trackingCodeLkid,
    };
};

export const handlePropUserAnalytics = () => {
    if (!window.objDataLayer.user) window.objDataLayer.user = {};
    window.objDataLayer.user.userID = '';
    window.objDataLayer.user.loginStatus = USER_LOGIN_STATUS.LOGGED_OUT;
};

export const handlePropVehicleAnalytics = (type?: string, brand?: string, model?: string, year?: string) => {
    if (!window.objDataLayer.vehicle) window.objDataLayer.vehicle = {};
    if (!window.objDataLayer.vehicle.type) window.objDataLayer.vehicle.type = {};
    if (!window.objDataLayer.vehicle.make) window.objDataLayer.vehicle.make = {};
    if (!window.objDataLayer.vehicle.model) window.objDataLayer.vehicle.model = {};
    if (!window.objDataLayer.vehicle.year) window.objDataLayer.vehicle.year = { model: {} };

    window.objDataLayer.vehicle.type.name = type;
    window.objDataLayer.vehicle.make.name = brand;
    window.objDataLayer.vehicle.model.name = model;
    window.objDataLayer.vehicle.year.model.value = year;
};

/**
 * Dispatches a custom event and optionally updates the global `objDataLayer` object.
 *
 * @param {string} event - The name of the event to dispatch. This is required.
 * @param {object} data - The data to include with the event. This is required.
 * @param {string} [value] - The value to set in the `objDataLayer` object. Optional.
 * @param {string} [node] - The top-level key in the `objDataLayer` object to update. Optional.
 * @param {string} [key] - The sub-key under `node` in the `objDataLayer` object to update. Optional.
 *
 * If `value`, `node`, and `key` are provided, the function will update the `objDataLayer` object
 * at `objDataLayer[node][key]` with the given `value`. This is useful for tracking additional
 * metadata related to the event.
 *
 * Example usage:
 * dispatchCustomEvent('customEventName', { detail: { foo: 'bar' } }, 'someValue', 'user', 'status');
 */
export const dispatchCustomEvent = (
    event: string,
    data: object,
    value?: string,
    node?: string,
    key?: string
) => {
    if (!event) {
        console.error('Evento não disparado por falta de um evento');
        return false;
    }

    if (!data) {
        console.error('Evento não disparado por falta de conteúdo');
        return false;
    }

    document.dispatchEvent(new CustomEvent(event, data));

    if (node !== undefined && value !== undefined && key !== undefined) {
        if (!window.objDataLayer[node]) {
            window.objDataLayer[node] = {};
        }
        window.objDataLayer[node][key] = value;
        console.log(event, window.objDataLayer);
    }
};

export const handleDispatchInteractionEvent = (
    interaction: string,
    callback?: () => void
): void => {
    if (callback && typeof callback === "function") callback();
    
    if (!interaction) return;
    dispatchCustomEvent("userInteraction", { detail: interaction }, interaction, "page", "interaction");
};